import {
    PIX_LIST_PIX,
    PIX_FILTRO_PIX,
    PIX_DETALHE_PIX,
    PIX_APPEND_PIX,
    CLEAR_LIST_PIX,
    REPROCESS_PIX,
    REPROCESS_LOADING_PIX
} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    listpix: [],
    // filtropix: []
    detalhepix: null,
    reprocesspix: null,
    loadingreprocess: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PIX_FILTRO_PIX:
            return { ...state, listpix: action.payload }; // Substitui a lista na primeira página
        case PIX_APPEND_PIX:
            return { ...state, listpix: [...state.listpix, ...action.payload] }; // Concatena novos itens
        case PIX_DETALHE_PIX:
            return { ...state, detalhepix: action.payload };
        case CLEAR_LIST_PIX:
            return {
                ...state, listpix: [], // limpa a lista
            };
        case REPROCESS_PIX:
            return {
                ...state, reprocesspix: action.payload,
            };
        case REPROCESS_LOADING_PIX:
            return {
                ...state, loadingreprocess: action.payload,
            };
        default:
            return state;
    }
};